import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { DraggableBoardCard } from './DraggableBoardCard';
import { GTMProject, PipelineStage, STAGE_LABELS } from '../../types/pipeline';

interface BoardColumnProps {
  stage: PipelineStage;
  projects: GTMProject[];
  onCardClick: (project: GTMProject) => void;
}

export const BoardColumn: React.FC<BoardColumnProps> = ({ stage, projects, onCardClick }) => {
  const { setNodeRef, isOver } = useDroppable({ id: stage });

  return (
    <div
      ref={setNodeRef}
      className={`flex flex-col w-full md:w-72 md:flex-shrink-0 rounded-md border ${
        isOver ? 'border-primary-600 bg-primary-50' : 'border-neutral-200 bg-neutral-50'
      }`}
    >
      <div className="flex items-center justify-between px-3 py-2 border-b border-neutral-200">
        <span className="text-13 font-semibold text-neutral-700">{STAGE_LABELS[stage]}</span>
        <span className="text-xs text-neutral-400">{projects.length}</span>
      </div>
      <div className="p-2 flex-1 min-h-[60px]">
        {projects.length === 0 ? (
          <p className="text-xs text-neutral-400 text-center py-4">No projects</p>
        ) : (
          projects.map(p => (
            <DraggableBoardCard key={p.id} project={p} onClick={onCardClick} />
          ))
        )}
      </div>
    </div>
  );
};
